/**
 * --------------------------------------------------------------------------
 * Button visually impaired (v1.0.0): util/cookie.js
 * Licensed under MIT (https://github.com/veks/button-visually-impaired-javascript/blob/master/LICENSE.md)
 * --------------------------------------------------------------------------
 */
import Cookies from 'js-cookie';

const setCookie = function (name = '', value = '') {
  Cookies.set(`bvi_${name}`, value, { expires: 1 })
};

const getCookie = function (name = '') {
  return Cookies.get(`bvi_${name}`)
};

const removeCookie = function (name = '') {
  Cookies.remove(`bvi_${name}`)
};

export {
  setCookie,
  getCookie,
  removeCookie,
};
